import React from "react"

const defaultStyles = {}
const CustomInput = ({
  value = "",
  onChange,
  placeholder = "",
  className,
  styles = defaultStyles,
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value
    onChange(inputValue)
  }

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      style={styles}
      className={className}
    />
  )
}

export default CustomInput
